import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./assets/global.css?vue&type=style&index=0&lang=css&external"
import "./App.vue?vue&type=style&index=1&id=e45276ea&lang=css"

const __exports__ = script;

export default __exports__